export const APIScopes = [`api://${import.meta.env.VITE_API_CLIENT_ID}/user_impersonation`]
export const APIURL = import.meta.env.VITE_API_ROOT
export const APIEndpoints = {
	clientIntake: '/client-intake',
	common: '/common',
	client: '/clients',
	event: '/event',
	eventType: '/event/types',
	forecast: '/forecast',
	job: '/job',
	production: '/production',
	quote: '/quotes',
	scenarioSubjob: '/scenarioSubjob',
	subJob: '/subjob',
	siteCapacity: '/siteCapacity',
	vendor: '/vendors'
}
